export default {
  '2D Contour Histogram': '⇚⇚⇚⇚2D Contour Histogram⇚⇚⇚⇚',
  '2D Histogram': '⇚⇚2D Histogram⇚⇚',
  '3D Scatter': '⇚⇚3D Scatter⇚⇚',
  All: '⇚All⇚',
  'Anchor Point': '⇚⇚Anchor Point⇚⇚',
  Angle: '⇚Angle⇚',
  Annotation: '⇚⇚Annotation⇚⇚',
  Area: '⇚Area⇚',
  Arrow: '⇚Arrow⇚',
  Arrowhead: '⇚⇚Arrowhead⇚⇚',
  'Atlas Map': '⇚⇚Atlas Map⇚⇚',
  Auto: '⇚Auto⇚',
  Autoscale: '⇚⇚Autoscale⇚⇚',
  Axes: '⇚Axes⇚',
  'Background Color': '⇚⇚⇚Background Color⇚⇚⇚',
  Bar: '⇚Bar⇚',
  'Bar Padding': '⇚⇚Bar Padding⇚⇚',
  'Bar Width': '⇚⇚Bar Width⇚⇚',
  Bars: '⇚Bars⇚',
  Blank: '⇚Blank⇚',
  'Border Color': '⇚⇚Border Color⇚⇚',
  'Border Width': '⇚⇚Border Width⇚⇚',
  Bottom: '⇚Bottom⇚',
  Box: '⇚Box⇚',
  'Box Padding': '⇚⇚Box Padding⇚⇚',
  'Box Select': '⇚⇚Box Select⇚⇚',
  'Box Width': '⇚⇚Box Width⇚⇚',
  Candlestick: '⇚⇚Candlestick⇚⇚',
  Canvas: '⇚Canvas⇚',
  Carpet: '⇚Carpet⇚',
  'Carpet Contour': '⇚⇚Carpet Contour⇚⇚',
  'Carpet Scatter': '⇚⇚Carpet Scatter⇚⇚',
  Center: '⇚Center⇚',
  Choropleth: '⇚⇚Choropleth⇚⇚',
  'Click to enter Colorscale title':
    '⇚⇚⇚⇚⇚Click to enter Colorscale title⇚⇚⇚⇚⇚',
  'Click to enter Component A title':
    '⇚⇚⇚⇚⇚⇚Click to enter Component A title⇚⇚⇚⇚⇚⇚',
  'Click to enter Component B title':
    '⇚⇚⇚⇚⇚⇚Click to enter Component B title⇚⇚⇚⇚⇚⇚',
  'Click to enter Component C title':
    '⇚⇚⇚⇚⇚⇚Click to enter Component C title⇚⇚⇚⇚⇚⇚',
  'Click to enter Plot title': '⇚⇚⇚⇚Click to enter Plot title⇚⇚⇚⇚',
  'Click to enter X axis title': '⇚⇚⇚⇚⇚Click to enter X axis title⇚⇚⇚⇚⇚',
  'Click to enter Y axis title': '⇚⇚⇚⇚⇚Click to enter Y axis title⇚⇚⇚⇚⇚',
  'Collapse All': '⇚⇚Collapse All⇚⇚',
  Color: '⇚Color⇚',
  "Common Case: An 'All' tab might display this message because the X and Y tabs contain different settings.":
    "⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚Common Case: An 'All' tab might display this message because the X and Y tabs contain different settings.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚",
  'Compare data on hover': '⇚⇚⇚⇚Compare data on hover⇚⇚⇚⇚',
  Connect: '⇚Connect⇚',
  'Connect Gaps': '⇚⇚Connect Gaps⇚⇚',
  Continue: '⇚Continue⇚',
  'Continuing will convert your LaTeX expression into raw text.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚Continuing will convert your LaTeX expression into raw text.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  'Continuing will convert your note to LaTeX-style text.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚Continuing will convert your note to LaTeX-style text.⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  'Continuing will remove your expression.':
    '⇚⇚⇚⇚⇚⇚⇚Continuing will remove your expression.⇚⇚⇚⇚⇚⇚⇚',
  Contour: '⇚Contour⇚',
  Custom: '⇚Custom⇚',
  'Custom Color': '⇚⇚Custom Color⇚⇚',
  'Default Colors': '⇚⇚Default Colors⇚⇚',
  Display: '⇚Display⇚',
  'Double-click on legend to isolate one trace':
    '⇚⇚⇚⇚⇚⇚⇚⇚Double-click on legend to isolate one trace⇚⇚⇚⇚⇚⇚⇚⇚',
  'Double-click to zoom back out': '⇚⇚⇚⇚⇚Double-click to zoom back out⇚⇚⇚⇚⇚',
  'Download plot as a png': '⇚⇚⇚⇚Download plot as a png⇚⇚⇚⇚',
  'Edit in Chart Studio': '⇚⇚⇚⇚Edit in Chart Studio⇚⇚⇚⇚',
  'Edit in HTML': '⇚⇚Edit in HTML⇚⇚',
  'Edit in Rich Text': '⇚⇚⇚Edit in Rich Text⇚⇚⇚',
  'Enter Link URL': '⇚⇚Enter Link URL⇚⇚',
  'Expand All': '⇚⇚Expand All⇚⇚',
  'Filled Area': '⇚⇚Filled Area⇚⇚',
  'Fixed Height': '⇚⇚Fixed Height⇚⇚',
  'Fixed Width': '⇚⇚Fixed Width⇚⇚',
  'Font Color': '⇚⇚Font Color⇚⇚',
  'Font Size': '⇚⇚Font Size⇚⇚',
  'Global Font': '⇚⇚Global Font⇚⇚',
  'Go back': '⇚Go back⇚',
  "Go to the 'Create' tab to define traces.":
    "⇚⇚⇚⇚⇚⇚⇚Go to the 'Create' tab to define traces.⇚⇚⇚⇚⇚⇚⇚",
  'Heads up!': '⇚⇚Heads up!⇚⇚',
  Heatmap: '⇚Heatmap⇚',
  'Heatmap GL': '⇚⇚Heatmap GL⇚⇚',
  Hide: '⇚Hide⇚',
  Histogram: '⇚⇚Histogram⇚⇚',
  Horizontal: '⇚⇚Horizontal⇚⇚',
  'Horizontal Positioning': '⇚⇚⇚⇚Horizontal Positioning⇚⇚⇚⇚',
  'IE only supports svg.  Changing format to svg.':
    '⇚⇚⇚⇚⇚⇚⇚⇚IE only supports svg.  Changing format to svg.⇚⇚⇚⇚⇚⇚⇚⇚',
  LaTeX: '⇚LaTeX⇚',
  "LaTeX is a math typesetting language that doesn't work with rich text.":
    "⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚LaTeX is a math typesetting language that doesn't work with rich text.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚",
  'Lasso Select': '⇚⇚Lasso Select⇚⇚',
  Layout: '⇚Layout⇚',
  Left: '⇚Left⇚',
  Legend: '⇚Legend⇚',
  'Legend Box': '⇚⇚Legend Box⇚⇚',
  Line: '⇚Line⇚',
  'Line Color': '⇚⇚Line Color⇚⇚',
  'Line Width': '⇚⇚Line Width⇚⇚',
  Linear: '⇚Linear⇚',
  Lines: '⇚Lines⇚',
  "Looks like there aren't any traces defined yet.":
    "⇚⇚⇚⇚⇚⇚⇚⇚Looks like there aren't any traces defined yet.⇚⇚⇚⇚⇚⇚⇚⇚",
  'Margin Color': '⇚⇚Margin Color⇚⇚',
  'Margins and Padding': '⇚⇚⇚Margins and Padding⇚⇚⇚',
  Max: '⇚Max⇚',
  Mesh3d: '⇚Mesh3d⇚',
  Middle: '⇚Middle⇚',
  Min: '⇚Min⇚',
  'Multiple Values': '⇚⇚⇚Multiple Values⇚⇚⇚',
  'No Results': '⇚⇚No Results⇚⇚',
  Normal: '⇚Normal⇚',
  'Note Text': '⇚⇚Note Text⇚⇚',
  Notes: '⇚Notes⇚',
  OHLC: '⇚OHLC⇚',
  Opacity: '⇚Opacity⇚',
  'Orbital rotation': '⇚⇚⇚Orbital rotation⇚⇚⇚',
  Orientation: '⇚⇚Orientation⇚⇚',
  Padding: '⇚Padding⇚',
  Pan: '⇚Pan⇚',
  'Parallel Coordinates': '⇚⇚⇚⇚Parallel Coordinates⇚⇚⇚⇚',
  Pie: '⇚Pie⇚',
  'Plot Background': '⇚⇚⇚Plot Background⇚⇚⇚',
  'Point Cloud': '⇚⇚Point Cloud⇚⇚',
  Points: '⇚Points⇚',
  'Polar Scatter': '⇚⇚Polar Scatter⇚⇚',
  Position: '⇚Position⇚',
  Positioning: '⇚⇚Positioning⇚⇚',
  'Produced with Plotly': '⇚⇚⇚⇚Produced with Plotly⇚⇚⇚⇚',
  Range: '⇚Range⇚',
  'Relative To': '⇚⇚Relative To⇚⇚',
  Reset: '⇚Reset⇚',
  'Reset axes': '⇚⇚Reset axes⇚⇚',
  'Reset camera to default': '⇚⇚⇚⇚Reset camera to default⇚⇚⇚⇚',
  'Reset camera to last save': '⇚⇚⇚⇚Reset camera to last save⇚⇚⇚⇚',
  'Reset view': '⇚⇚Reset view⇚⇚',
  'Reset views': '⇚⇚Reset views⇚⇚',
  'Return to the Graph > Create menu above to add data.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚Return to the Graph > Create menu above to add data.⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  Reversed: '⇚Reversed⇚',
  'Rich Text': '⇚⇚Rich Text⇚⇚',
  'Rich text is incompatible with LaTeX.':
    '⇚⇚⇚⇚⇚⇚Rich text is incompatible with LaTeX.⇚⇚⇚⇚⇚⇚',
  Right: '⇚Right⇚',
  Sankey: '⇚Sankey⇚',
  'Satellite Map': '⇚⇚Satellite Map⇚⇚',
  Scale: '⇚Scale⇚',
  Scatter: '⇚Scatter⇚',
  'Scatter GL': '⇚⇚Scatter GL⇚⇚',
  'Select an Option': '⇚⇚⇚Select an Option⇚⇚⇚',
  Selection: '⇚⇚Selection⇚⇚',
  Shape: '⇚Shape⇚',
  Show: '⇚Show⇚',
  'Show closest data on hover': '⇚⇚⇚⇚⇚Show closest data on hover⇚⇚⇚⇚⇚',
  Size: '⇚Size⇚',
  'Size and Spacing': '⇚⇚⇚Size and Spacing⇚⇚⇚',
  'Snapshot succeeded': '⇚⇚⇚Snapshot succeeded⇚⇚⇚',
  'Sorry, there was a problem downloading your snapshot!':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚Sorry, there was a problem downloading your snapshot!⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  Surface: '⇚Surface⇚',
  Symbol: '⇚Symbol⇚',
  Table: '⇚Table⇚',
  'Taking snapshot - this may take a few seconds':
    '⇚⇚⇚⇚⇚⇚⇚⇚Taking snapshot - this may take a few seconds⇚⇚⇚⇚⇚⇚⇚⇚',
  'Ternary Scatter': '⇚⇚⇚Ternary Scatter⇚⇚⇚',
  Text: '⇚Text⇚',
  'Text Attributes': '⇚⇚⇚Text Attributes⇚⇚⇚',
  "The anchor point determines which side of the annotation's positioning coordinates refer to.":
    "⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚The anchor point determines which side of the annotation's positioning coordinates refer to.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚",
  'The positioning inputs are relative to the anchor points on the text box.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚The positioning inputs are relative to the anchor points on the text box.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  'This input has multiple values associated with it. Changing this setting will override these custom inputs.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚This input has multiple values associated with it. Changing this setting will override these custom inputs.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  'This trace does not yet have any data.':
    '⇚⇚⇚⇚⇚⇚⇚This trace does not yet have any data.⇚⇚⇚⇚⇚⇚⇚',
  'Tick Labels': '⇚⇚Tick Labels⇚⇚',
  'Tick Markers': '⇚⇚Tick Markers⇚⇚',
  Title: '⇚Title⇚',
  'Title and Fonts': '⇚⇚⇚Title and Fonts⇚⇚⇚',
  Titles: '⇚Titles⇚',
  'Toggle Spike Lines': '⇚⇚⇚Toggle Spike Lines⇚⇚⇚',
  'Toggle show closest data on hover':
    '⇚⇚⇚⇚⇚⇚Toggle show closest data on hover⇚⇚⇚⇚⇚⇚',
  Top: '⇚Top⇚',
  Trace: '⇚Trace⇚',
  'Trace Order': '⇚⇚Trace Order⇚⇚',
  'Trace opacity is not supported for a scatter trace with fill or for a scatter trace that gets filled by another scatter trace.':
    '⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚Trace opacity is not supported for a scatter trace with fill or for a scatter trace that gets filled by another scatter trace.⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚⇚',
  'Turntable rotation': '⇚⇚⇚Turntable rotation⇚⇚⇚',
  Type: '⇚Type⇚',
  Typeface: '⇚Typeface⇚',
  URL: '⇚URL⇚',
  Vertical: '⇚Vertical⇚',
  'Vertical Positioning': '⇚⇚⇚⇚Vertical Positioning⇚⇚⇚⇚',
  Violin: '⇚Violin⇚',
  Width: '⇚Width⇚',
  'X Position': '⇚⇚X Position⇚⇚',
  'X Vector': '⇚X Vector⇚',
  'Y Position': '⇚⇚Y Position⇚⇚',
  'Y Vector': '⇚Y Vector⇚',
  Zoom: '⇚Zoom⇚',
  'Zoom Interactivity': '⇚⇚⇚Zoom Interactivity⇚⇚⇚',
  'Zoom in': '⇚Zoom in⇚',
  'Zoom out': '⇚Zoom out⇚',
  'close:': '⇚close:⇚',
  'high:': '⇚high:⇚',
  'incoming flow count:': '⇚⇚⇚⇚incoming flow count:⇚⇚⇚⇚',
  'kde:': '⇚kde:⇚',
  'lat:': '⇚lat:⇚',
  log: '⇚log⇚',
  'lon:': '⇚lon:⇚',
  'low:': '⇚low:⇚',
  'lower fence:': '⇚⇚lower fence:⇚⇚',
  'max:': '⇚max:⇚',
  'mean ± σ:': '⇚⇚mean ± σ:⇚⇚',
  'mean:': '⇚mean:⇚',
  'median:': '⇚median:⇚',
  'min:': '⇚min:⇚',
  'open:': '⇚open:⇚',
  'outgoing flow count:': '⇚⇚⇚⇚outgoing flow count:⇚⇚⇚⇚',
  'q1:': '⇚q1:⇚',
  'q3:': '⇚q3:⇚',
  'source:': '⇚source:⇚',
  'target:': '⇚target:⇚',
  trace: '⇚trace⇚',
  'upper fence:': '⇚⇚upper fence:⇚⇚',
};
